import { ReadDefensoriaDto } from '@/api.types';
import { primeiroPeriodoRelatorioAposHabilitacao } from '@/modules/reports/application/relatorios-prazo-habilitacao.utils';
import { MESES } from '@/shared/utils/datas';
import { normalizeOptionalReference } from '@/shared/utils/formZod.schema.utils';

function str(value: unknown): string {
  return value == null ? '' : String(value);
}

function bool(value: unknown): boolean | undefined {
  if (value === null || value === undefined) return undefined;
  return value === true || value === 'true';
}

/** Converte ISO/Date da API para valor de input type="date" (yyyy-mm-dd). */
export function toDateInputValue(value: Date | string | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Normaliza resposta da API para o formulário (Zod não aceita `null` em string/boolean). */
export function normalizeDefensoriaFormFromApi(
  data: ReadDefensoriaDto,
): ReadDefensoriaDto {
  return {
    ...data,
    codigo: str(data.codigo),
    anotacao: str(data.anotacao),
    exibirrelatorio: bool(data.exibirrelatorio) ?? false,
    relatoriosAtividadesHabilitadoEm: toDateInputValue(
      data.relatoriosAtividadesHabilitadoEm as string | Date | null | undefined,
    ) as ReadDefensoriaDto['relatoriosAtividadesHabilitadoEm'],
    criminal: bool(data.criminal) ?? false,
    civel: bool(data.civel) ?? false,
    ordem: data.ordem ?? 0,
    maximo_estagiarios: data.maximo_estagiarios ?? 0,
    telefone: data.telefone
      ? {
          ...data.telefone,
          numero: str(data.telefone.numero),
        }
      : data.telefone,
    defensoriasubstituta1: normalizeOptionalReference(data.defensoriasubstituta1) as
      | ReadDefensoriaDto
      | undefined,
    defensoriasubstituta2: normalizeOptionalReference(data.defensoriasubstituta2) as
      | ReadDefensoriaDto
      | undefined,
    diretoria: normalizeOptionalReference(data.diretoria),
  };
}

/** Ex.: "Fevereiro/2026" a partir da data de habilitação da defensoria. */
export function formatarPrimeiroPeriodoRelatorio(
  habilitadoEm: Date | string | null | undefined,
): string {
  let valor: Date | string | null | undefined = habilitadoEm;
  if (typeof habilitadoEm === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(habilitadoEm.trim())) {
    valor = `${habilitadoEm.trim()}T12:00:00.000Z`;
  }
  const periodo = primeiroPeriodoRelatorioAposHabilitacao(valor);
  const nomeMes = MESES[periodo.mes - 1] ?? String(periodo.mes).padStart(2, '0');
  return `${nomeMes}/${periodo.ano}`;
}
